import React from 'react'

import { ZariContext } from '_zari/context'

import { Portlet, Table } from '_zari/core'

import { CodigosTransaccionesConstant, OrigenesContabilidadConstant } from 'constants/index'

import * as PlantillaGeneralService from 'services/plantillaGeneralContabilidad.service'

const portletBreadcrumbs = [{ name: 'Plantillas Generales' }]

const tableHeaderRows = [{ label: 'ORIGEN' }, { label: 'TITULO' }, { label: '', width: 60 }]

const ListaPage = ({ history }) => {
  const __zariContext = React.useContext(ZariContext)

  const tablaRef = React.useRef(null)

  const clickNuevo = React.useCallback(() => {
    history.push(`/${CodigosTransaccionesConstant.PLANTILLASGENERALESCONTABILIDAD_NUEVO}`)
  }, [history])

  const clickEditar = React.useCallback(
    ({ _id }) => {
      history.push(`/${CodigosTransaccionesConstant.PLANTILLASGENERALESCONTABILIDAD_EDITAR}/${_id}`)
    },
    [history]
  )

  const clickEliminar = React.useCallback(
    async ({ _id }) => {
      await PlantillaGeneralService.eliminarxId(_id)
        .then(() => {
          __zariContext.snack('success', 'Registro eliminado!')
          tablaRef.current.reload()
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    },
    [__zariContext]
  )
  return (
    <Portlet>
      <Portlet.Header
        title='Plantillas Generales'
        breadcrumbs={portletBreadcrumbs}
        buttons={[{ name: 'Nuevo', onClick: clickNuevo }]}
      />
      <Portlet.Body>
        <Table.ServerSide
          useNest={true}
          ref={tablaRef}
          url='/plantillasgenerales-contabilidad'
          headRows={tableHeaderRows}
          rowTemplate={row => (
            <Table.Row key={row._id}>
              <Table.Cell>
                {row.origen ? OrigenesContabilidadConstant.__dictionary[row.origen].nombre : '--'}
              </Table.Cell>
              <Table.Cell>{row.titulo || '--'}</Table.Cell>
              <Table.Cell>
                <Table.Dropdown>
                  {({ handleClose }) => [
                    <Table.Dropdown.Item
                      key='editar'
                      handleClose={handleClose}
                      onClick={e => clickEditar({ _id: row._id })}
                    >
                      Editar
                    </Table.Dropdown.Item>,
                    <Table.Dropdown.Item
                      key='eliminar'
                      handleClose={handleClose}
                      onClick={e => clickEliminar({ _id: row._id })}
                    >
                      Eliminar
                    </Table.Dropdown.Item>
                  ]}
                </Table.Dropdown>
              </Table.Cell>
            </Table.Row>
          )}
        />
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(ListaPage)
